import {gql} from 'apollo-angular';
import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {I18NEXT_SERVICE, I18NextLoadResult, ITranslationService} from 'angular-i18next';
import {AuthService} from 'app/core/services/auth.service';
import {ApiService} from 'app/shared/modules/api/services/api.service';
import {CookieService} from 'ngx-cookie-service';
import {DemoService} from 'app/core/services/demo.service';

const DEFAULT_LANGUAGE_COOKIE_KEY = 'locale';

export const setLocaleMutation = gql`
    mutation setLocale($locale: String!) {
        setLocale(locale: $locale)
    }
`;

@Injectable()
export class LanguageSwitcherService {
    get language() {
        return this.locale;
    }

    get availableLanguages(): string[] {
        return (this.i18NextService.options.supportedLngs as string[]) || [];
    }

    constructor(
        @Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService,
        @Inject(LOCALE_ID) private locale: string,
        private auth: AuthService,
        private api: ApiService,
        private cookieService: CookieService,
        private demo: DemoService
    ) {}

    getCookieLangKey() {
        let key;
        try {
            // @ts-ignore
            key = this.i18NextService.options.detection.lookupCookie;
        } finally {
            key = key || DEFAULT_LANGUAGE_COOKIE_KEY;
        }
        return key;
    }

    updateCookieLang(lng: string) {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 100);
        this.cookieService.set(this.getCookieLangKey(), lng, date, '/');
        return Promise.resolve({});
    }

    updateProfileLang(lng: string) {
        return this.api
            .mutate({
                mutation: setLocaleMutation,
                variables: {
                    locale: lng,
                },
            })
            .toPromise();
    }

    changeLanguage(lng: string): Promise<I18NextLoadResult> {
        return this.auth
            .init()
            .then(user => (user && !this.demo.isDemoHost ? this.updateProfileLang(lng) : this.updateCookieLang(lng)))
            .then(() => this.reload())
            .then(() => this.i18NextService.changeLanguage(lng));
    }

    /* istanbul ignore next */
    reload() {
        location.reload();
    }
}
